module.exports = __webpack_public_path__ + "static/media/remove-file.5a58ef4a.svg";